module.exports = __webpack_public_path__ + "static/media/favicon.9402ac52.png";